import { askDate, type NextServiceAnchor, type NextServiceAskRules } from '../core/ask.js';
import type { HotelNextServicesBlock } from '@voll-intelligence/genui-contract';

/** O pós-hotel (#2349) ancora no HOTEL reservado; sem `hotelName` (skew de
 *  contrato — o emissor do agents o garante) a linha degrada para «essa
 *  viagem». `seat`, `hotel` e `flight` ficam fora do catálogo default, mas o
 *  agents pode injetar qualquer id do enum e toda linha precisa de pedido. */
export const HOTEL_ASK_RULES: NextServiceAskRules = {
  car: {
    window: {
      range: 'hotel.nextServices.ask.carRange',
      open: 'hotel.nextServices.ask.carOpen',
      bare: 'hotel.nextServices.ask.carBare',
      trip: 'hotel.nextServices.ask.carTrip',
    },
  },
  train: { anchored: 'hotel.nextServices.ask.train', trip: 'hotel.nextServices.ask.trainTrip' },
  bus: { anchored: 'hotel.nextServices.ask.bus', trip: 'hotel.nextServices.ask.busTrip' },
  insurance: { fixed: 'hotel.nextServices.ask.insurance' },
  seat: { fixed: 'hotel.nextServices.ask.seat' },
  hotel: { fixed: 'hotel.nextServices.ask.hotel' },
  flight: { fixed: 'hotel.nextServices.ask.flight' },
  transfer_to_airport: { fixed: 'hotel.nextServices.ask.transferToAirport' },
  transfer_airport_hotel: { fixed: 'hotel.nextServices.ask.transferAirportHotel' },
  transfer_to_hotel: { fixed: 'hotel.nextServices.ask.transferToHotel' },
};

/** O hotel e a estadia (`hotelName`, `checkIn`, `checkOut`) do carrinho. */
export function hotelAnchor(block: HotelNextServicesBlock, locale: string): NextServiceAnchor {
  const detail = block.items.find((item) => item.productType === 'hotel')?.detail;
  return {
    param: 'hotel',
    value: detail?.hotelName ?? null,
    from: askDate(detail?.checkIn, locale),
    to: askDate(detail?.checkOut, locale),
  };
}
